import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";

import { InputAdornment } from "@mui/material";
import { TextFieldProps } from "@mui/material";

import { TextField } from "./TextField";

const useStyles = makeStyles()((theme) => ({
    adornment: {
        width: theme.spacing(5),
        textAlign: "center",
    },
    toggle: {
        cursor: "pointer",
    },
}));

interface PasswordFieldProps extends Omit<TextFieldProps, "type"> {
    name: string;
    showErrorOnSubmit?: boolean;
}

const PasswordField = (props: PasswordFieldProps) => {
    const [showPassword, setShowPassword] = useState(false);
    const { classes, cx } = useStyles();

    return (
        <TextField
            {...props}
            type={showPassword ? "text" : "password"}
            slotProps={{
                ...props.slotProps,
                input: {
                    ...props.slotProps?.input,
                    endAdornment: (
                        <InputAdornment position="end">
                            <div className={classes.adornment}>
                                <i
                                    className={cx(showPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye", classes.toggle)}
                                    onClick={() => setShowPassword((prev) => !prev)}
                                />
                            </div>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};

export default PasswordField;
